// Centralized brand & asset config for Equinoxe Groupe
import { Briefcase, Shield, Sparkles } from "lucide-react";

export const LOGOS = {
  groupe: "https://customer-assets.emergentagent.com/job_enterprise-hub-357/artifacts/6igcdzom_Equinoxe_Groupe_noir.png",
  studio: "https://customer-assets.emergentagent.com/job_enterprise-hub-357/artifacts/olc2lzoj_Equinoxe_Studio_blanc.png",
  securite: "https://customer-assets.emergentagent.com/job_enterprise-hub-357/artifacts/cxr11fms_Equinoxe_Securite_blanc.png",
  proprete: "https://customer-assets.emergentagent.com/job_enterprise-hub-357/artifacts/wiuumr7p_Equinoxe_Proprete_blanc-resize.png",
};

export const HERO_IMAGES = {
  groupe: "https://images.pexels.com/photos/17187918/pexels-photo-17187918.jpeg",
  about: "https://images.pexels.com/photos/9701960/pexels-photo-9701960.jpeg",
  studio: "https://images.pexels.com/photos/8463151/pexels-photo-8463151.jpeg",
  securite: "https://images.unsplash.com/photo-1652739758426-56a564265f9e",
  proprete: "https://images.unsplash.com/photo-1564078516393-cf04bd966897",
};

export const BRANCHES = {
  studio: {
    key: "studio",
    name: "Equinoxe Studio",
    short: "Studio",
    tagline: "Communication commerciale & opérationnelle",
    description:
      "Conseils stratégiques, management, cohésion d'équipe, prospection terrain et téléphonique, gestion de planning et conception de supports de communication.",
    accent: "#8b5cf6",
    accentSoft: "rgba(139, 92, 246, 0.12)",
    accentText: "text-violet-400",
    accentBorder: "border-violet-500/40",
    accentBg: "bg-violet-500",
    accentRing: "ring-violet-500",
    btnHover: "hover:bg-violet-500 hover:text-white hover:border-violet-500",
    Icon: Briefcase,
    glow: "glow-studio",
    logoScale: 1.0,
    services: [
      "Conseils stratégiques aux entreprises",
      "Management & cohésion d'équipe",
      "Commerciaux terrain",
      "Prospection téléphonique",
      "Gestion de planning",
      "Conception de supports de communication",
      "Autre",
    ],
  },
  securite: {
    key: "securite",
    name: "Equinoxe Sécurité",
    short: "Sécurité",
    tagline: "Solutions en sûreté et sécurité incendie",
    description:
      "Sûreté et sécurité incendie pour vos événements festifs, sportifs, culturels ou privés, vos magasins et locaux à usage professionnel.",
    accent: "#ea580c",
    accentSoft: "rgba(234, 88, 12, 0.12)",
    accentText: "text-orange-500",
    accentBorder: "border-orange-500/40",
    accentBg: "bg-orange-600",
    accentRing: "ring-orange-500",
    btnHover: "hover:bg-orange-600 hover:text-white hover:border-orange-600",
    Icon: Shield,
    glow: "glow-securite",
    logoScale: 1.0,
    services: [
      "Sécurité d'événements festifs, culturels & sportifs",
      "Agents de sécurité confirmés",
      "Agents cynophiles",
      "Surveillance de magasin",
      "Sécurité de locaux professionnels",
      "Sécurité incendie (SSIAP 1, 2, 3)",
      "Autre",
    ],
  },
  proprete: {
    key: "proprete",
    name: "Equinoxe Propreté",
    short: "Propreté",
    tagline: "Entretien int./ext. • Débarras • Désinfection",
    description:
      "Entretien intérieur et extérieur de votre résidence principale, secondaire ou de vos locations : espaces verts, ménage, débarras, désinfection, remise en état avant vente ou location.",
    accent: "#0ea5e9",
    accentSoft: "rgba(14, 165, 233, 0.12)",
    accentText: "text-sky-400",
    accentBorder: "border-sky-500/40",
    accentBg: "bg-sky-500",
    accentRing: "ring-sky-500",
    btnHover: "hover:bg-sky-500 hover:text-white hover:border-sky-500",
    Icon: Sparkles,
    glow: "glow-proprete",
    logoScale: 1.0,
    services: [
      "Ménage & entretien intérieur",
      "Entretien extérieur & espaces verts",
      "Débarras et désinfection tous locaux",
      "Remise en état avant vente ou location",
      "Nettoyage de véhicule int./ext.",
      "Entretien et fleurissement de sépultures",
      "Autre",
    ],
  },
};

export const BRANCH_LIST = [BRANCHES.studio, BRANCHES.securite, BRANCHES.proprete];
